import React from "react";
import { Box, Typography, Grid2 as Grid, Link } from "@mui/material";
import { useEntityHandlerContext } from "../../../controllers/entityController";
import { LinksList } from "../../forms/common/subForms/LinksListField";
import { normalizeHttpUrl } from "../../../common/formatters/linkUrls";
// @ts-ignore
import bdrcLogo from "../../../assets/link-logos/bdrc_logo.png";
// @ts-ignore
import muktabodhaLogo from "../../../assets/link-logos/Muktabodha_logo.png";
// @ts-ignore
import gretilLogo from "../../../assets/link-logos/GRETIL_logo.png";
// @ts-ignore
import otherLogo from "../../../assets/link-logos/other_logo.png";

interface ViewLinksFieldProps {
  name: string;
  label: string;
  placeholder?: string;
}

const LINK_TYPE_LOGO_MAP: Record<string, string> = {
  bdrc: bdrcLogo,
  muktabodha: muktabodhaLogo,
  gretil: gretilLogo,
  other: otherLogo,
};

const getLinkTypeLogo = (linkType?: string | null): string =>
  LINK_TYPE_LOGO_MAP[(linkType || "").trim().toLowerCase()] ?? otherLogo;

const ViewLinksField: React.FC<ViewLinksFieldProps> = ({
  name,
  label,
  placeholder = "No Links",
}) => {
  const { methods } = useEntityHandlerContext();
  const data = methods.getValues();
  const rawValue = data?.[name as keyof typeof data];
  const links = Array.isArray(rawValue) ? (rawValue as LinksList) : [];

  const renderLinkItem = (item: LinksList[number], index: number) => {
    const linkType = item.type || "";
    const normalizedUrl = normalizeHttpUrl(item.link);
    const logoSrc = getLinkTypeLogo(linkType);
    const linkText = linkType || normalizedUrl || item.link || "";

    if (!normalizedUrl) {
      return (
        <Box key={index}>
          {item.link ? `${linkType} (${item.link})` : linkType}
        </Box>
      );
    }

    return (
      <Box
        key={index}
        sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
      >
        {logoSrc ? (
          <Link
            href={normalizedUrl}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{ display: "inline-flex", alignItems: "center" }}
          >
            <Box
              component="img"
              src={logoSrc}
              alt={`${linkType} logo`}
              sx={{ width: 28, height: 28, objectFit: "contain" }}
            />
          </Link>
        ) : null}
        <Link
          href={normalizedUrl}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {linkText}
        </Link>
      </Box>
    );
  };

  return (
    <Grid size={{ xs: 12 }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 0.5 }}
        >
          {label}
        </Typography>
        <Typography component="div" variant="body1">
          {links.length > 0 ? links.map(renderLinkItem) : placeholder}
        </Typography>
      </Box>
    </Grid>
  );
};

export default ViewLinksField;
